import './PaymentMethods.sass';

import React, { FC, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslator } from '$hooks';

import { mainActions } from '$store/main';
import { balanceActions } from '$store/balance';
import { paymentMethodsActions, paymentMethodsSelector } from '$store/paymentMethods';

import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { BankCard, Loader, MetaTags } from '$shared/components';
import { Button, Header, Placeholder, ScrollView, Card, PullToRefresh } from '$uikit';

import { IcPlusCircle28, IcEdit28, IcCheck28, IcAdd28, IcBankCard56 } from '$assets';

export const PaymentMethods: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { isLoading, cards } = useSelector(paymentMethodsSelector);
  const [status, setStatus] = useState<boolean>(false);

  const handleAddCard = useCallback(() => {
    dispatch(balanceActions.attachCard());
  }, []);

  useEffect(() => {
    if (!cards?.length) {
      setStatus(false);
    }
  }, [cards]);

  useEffect(() => {
    dispatch(paymentMethodsActions.loadCards());

    return () => {
      dispatch(paymentMethodsActions.clear());
    };
  }, []);

  function renderNoCardPlaceholder() {
    return (
      <Placeholder
        icon={<IcBankCard56 width={80} height={80} />}
        iconSize={80}
        centered
        // actions={
        //   <Button onClick={handleAddCard} iconRight={<IcPlusCircle28 />}>
        //     {t('payment_methods_add_card_placeholder_button')}
        //   </Button>
        // }
        title={t('payment_methods_add_card_placeholder_title')}
      >
        {t('payment_methods_add_card_placeholder_text')}
      </Placeholder>
    );
  }

  function renderPopup(card) {
    return (
      <BottomSheet title={t('payment_methods_remove_card_popup_title')}>
        <p className="PaymentMethods__BottomSheet__text">
          {t('payment_methods_remove_card_popup_text_1')}{' '}
          <b>
            {card.brand.toUpperCase()} *{card.last4}
          </b>{' '}
          {t('payment_methods_remove_card_popup_text_2')}
        </p>
        <div className="PaymentMethods__BottomSheet__buttons">
          <Button
            className="PaymentMethods__button"
            mode="secondary"
            color="red"
            onClick={() => {
              dispatch(paymentMethodsActions.removeCard({ id: card.id }));
              dispatch(mainActions.setPopup(null));
            }}
          >
            {t('payment_methods_remove_card_popup_button_remove')}
          </Button>
          <Button
            className="PaymentMethods__button"
            mode="secondary"
            onClick={() => dispatch(mainActions.setPopup(null))}
          >
            {t('payment_methods_remove_card_popup_button_keep_it')}
          </Button>
        </div>
      </BottomSheet>
    );
  }

  function renderLoading() {
    return (
      <Placeholder>
        <Loader mode="additional" />
      </Placeholder>
    );
  }

  function renderContent() {
    return (
      <>
        {cards?.map((item) => (
          <BankCard
            key={`bank-card-${item.id}`}
            cardId={item.id}
            cardNumber={item.last4}
            popup={renderPopup}
            type={item.brand}
            isActive={item.active}
            isEdit={status}
          />
        ))}
        {/* <Card
          title={t('payment_methods_add_card_button')}
          onClick={handleAddCard}
          before={
            <div className="PaymentMethods__CardAdd">
              <IcAdd28 width={24} height={24} />
            </div>
          }
        >
          {t('payment_methods_add_card_title', { amount: 5 })}
        </Card> */}
      </>
    );
  }

  return (
    <>
      <MetaTags title={t('payment_methods_content')} />
      <Header
        rightIcons={
          cards?.length
            ? [
                {
                  icon: <IcEdit28 width={22} height={22} />,
                  onClick: () => setStatus(!status),
                  visible: !status,
                },
                {
                  icon: <IcCheck28 />,
                  onClick: () => setStatus(!status),
                  visible: status,
                },
              ]
            : undefined
        }
        showBackButton
      >
        {t('payment_methods_content')}
      </Header>
      <ScrollView>
        <PullToRefresh
          isRefreshing={isLoading}
          onRefresh={() => dispatch(paymentMethodsActions.loadCards())}
        >
          {!cards
            ? renderLoading()
            : !cards?.length
            ? renderNoCardPlaceholder()
            : renderContent()}
        </PullToRefresh>
      </ScrollView>
    </>
  );
};
